import { httpClient } from './http'

export async function createCast({ text, gallery }, apikey) {
  try {
    const res = await httpClient.post(
      '/v1/broadcasts',
      { text, gallery },
      { params: { apikey } }
    )
    return res.data.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function sendBroadcast(id, { min, max }, apikey) {
  try {
    const res = await httpClient.post(
      '/v1/broadcasts/' + id,
      { flutterappversion: { min, max } },
      { params: { apikey } }
    )
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}
